export default function Industries() {
  const industries = [
    {
      icon: 'ri-scales-3-line',
      title: 'Law Firms',
      description: 'Automate consultation intake, client follow-ups, and case-lead management while maintaining a professional client experience.',
      benefits: [
        'reduce intake leakage',
        'improve consult conversion',
        'streamline client communication'
      ]
    },
    {
      icon: 'ri-calculator-line',
      title: 'CPA & Tax Firms',
      description: 'AI systems that organize client intake, automate reminders, and streamline recurring tax workflows.',
      benefits: [
        'reduce administrative workload',
        'improve client responsiveness',
        'increase seasonal capacity'
      ]
    },
    {
      icon: 'ri-leaf-line',
      title: 'Medspas & Aesthetic Clinics',
      description: 'Automation designed to fill appointment calendars and maximize treatment bookings.',
      benefits: [
        'automated follow-ups',
        'membership retention workflows',
        'high-ticket conversion sequences'
      ]
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Mental Health Practices',
      description: 'AI-supported intake and scheduling systems designed to reduce no-shows and administrative friction.',
      benefits: [
        'improved intake experience',
        'structured reminders',
        'optimized scheduling'
      ]
    },
    {
      icon: 'ri-home-gear-line',
      title: 'Home Services',
      description: 'Automation systems that ensure no leads are lost and recurring service opportunities are captured.',
      benefits: [
        'missed call automation',
        'follow-up sequences',
        'recurring maintenance reminders'
      ]
    }
  ];

  return (
    <section className="py-32 bg-white dark:bg-[#0a1520] transition-colors duration-300">
      <div className="max-w-[1440px] mx-auto px-20">
        <h2 className="text-5xl font-semibold text-center text-[#0E1A2B] dark:text-[#e8edf4] mb-6">
          Specialized AI Systems by Industry
        </h2>
        
        <p className="text-lg text-center text-[#5C6675] dark:text-[#8899aa] max-w-[720px] mx-auto mb-20">
          Each Sapentis AI solution is adapted to the operational realities of the industries we serve.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24">
          {industries.map((industry, idx) => (
            <div
              key={idx}
              className="bg-white dark:bg-[#0c1a28] rounded-2xl border border-[#D9DEE5] dark:border-[#1e3247] p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-[#2F6BFF] dark:hover:border-[#28D7C6] cursor-pointer group"
            >
              <div className="w-16 h-16 flex items-center justify-center mb-6 bg-[#2F6BFF]/5 dark:bg-[#28D7C6]/10 rounded-xl group-hover:bg-[#2F6BFF]/10 dark:group-hover:bg-[#28D7C6]/20 transition-colors">
                <i className={`${industry.icon} text-[48px] text-[#2F6BFF] dark:text-[#28D7C6]`}></i>
              </div>
              
              <h3 className="text-xl font-semibold text-[#0E1A2B] dark:text-[#e8edf4] mb-4">
                {industry.title}
              </h3>
              
              <p className="text-base text-[#5C6675] dark:text-[#8899aa] leading-relaxed mb-6">
                {industry.description}
              </p>
              
              <div className="space-y-3">
                {industry.benefits.map((benefit, bidx) => (
                  <div key={bidx} className="flex items-start gap-3">
                    <div className="w-1 h-1 rounded-full bg-[#28D7C6] mt-2 flex-shrink-0"></div>
                    <span className="text-sm text-[#5C6675] dark:text-[#8899aa] leading-relaxed">
                      {benefit}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#0E1A2B] to-[#1a2d47] dark:from-[#060d16] dark:to-[#0e1b2c] rounded-3xl p-16 text-center relative overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div className="absolute top-0 left-0 w-full h-full" style={{
              backgroundImage: `repeating-linear-gradient(0deg, transparent, transparent 49px, #28D7C6 49px, #28D7C6 50px),
                               repeating-linear-gradient(90deg, transparent, transparent 49px, #28D7C6 49px, #28D7C6 50px)`
            }}></div>
          </div>
          
          <div className="relative z-10">
            <h2 className="text-4xl font-semibold text-white mb-8">
              AI Designed for the Way Your Industry Actually Operates
            </h2>
            
            <button className="bg-[#28D7C6] text-[#0E1A2B] px-10 py-4 rounded-full text-base font-semibold hover:bg-[#20c4b5] transition-all whitespace-nowrap cursor-pointer hover:scale-105">
              Book a Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}